import React, { useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
// Data
import { updateUser } from "../../redux/apiCalls"
// Components
import Grid from "../Grid/Grid"
// Styles
import { Container, Details, Icon, IconWrapper, Image, ImageContainer, MobileIcon, ProductDetail, ProductInfo, StyledLink } from "./Favorites.styles"
import { SearchOutlined, DeleteOutline } from "@mui/icons-material"

const Favorites = ({ products }) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const user = useSelector((state) => state.user.currentUser)
    const [favorites, setFavorites] = useState([...products])

    const handleDelete = async (id) => {
        setFavorites((prev) => prev.filter(
            (item) => item.variationId !== id)
        )
        let userUpdate = { ...user }
        let favorites = [...userUpdate.favoriteProducts]
        userUpdate.favoriteProducts = favorites.filter((item) => item.variationId !== id)
        await updateUser(user._id, userUpdate, dispatch)
    }

    return (
        <Container>
            <Grid>
                {favorites.map((product, index) => (
                    <ProductDetail key={product.variationId} tabIndex={index}>
                        <ImageContainer>
                            <Image src={product.imageUrl} />
                            <IconWrapper>
                                <Icon>
                                    <StyledLink
                                        to={`/product/${product.productId}/${product.variationId}`}
                                    >
                                        <SearchOutlined fontSize="large" />
                                    </StyledLink>
                                    <MobileIcon>
                                        <SearchOutlined
                                            fontSize="large"
                                            onClick={() => navigate(`/product/${product.productId}/${product.variationId}`)}
                                        />
                                    </MobileIcon>
                                </Icon>
                                <Icon>
                                    <DeleteOutline fontSize="large" onClick={() => handleDelete(product.variationId)} />
                                </Icon>
                            </IconWrapper>
                        </ImageContainer>
                        <Details>
                            <ProductInfo><b>{t("favorites.label.l1")} : </b>{product.model}</ProductInfo>
                            <ProductInfo><b>{t("favorites.label.l2")} : </b>{product.code}</ProductInfo>
                            <ProductInfo><b>{t("favorites.label.l3")} : </b>{product.detailedColor}</ProductInfo>
                            <ProductInfo><b>{t("favorites.label.l4")} : </b> {product.size}</ProductInfo>
                        </Details>
                    </ProductDetail>
                ))}
            </Grid>
        </Container>
    )
}

Favorites.propTypes = {
    products: PropTypes.arrayOf(PropTypes.object)
}

export default Favorites
